export type SupportedLanDataType = {
  mediumLocales: boolean;
  subtitleLocales: boolean;
  textLocales: boolean;
};

export type SupportedLanguagesType = {
  [locale: string]: SupportedLanDataType;
};

type SupportedLanguagesProps = {
  mediumLocales: string[];
  subtitleLocales: string[];
  textLocales: string[];
};

export const createSupportedLanguages = ({
  mediumLocales,
  subtitleLocales,
  textLocales
}: SupportedLanguagesProps): SupportedLanguagesType => {
  const allLocales = new Set([
    ...mediumLocales,
    ...subtitleLocales,
    ...textLocales
  ]);

  const result: SupportedLanguagesType = {};

  allLocales.forEach(locale => {
    result[locale] = {
      mediumLocales: mediumLocales.includes(locale),
      subtitleLocales: subtitleLocales.includes(locale),
      textLocales: textLocales.includes(locale)
    };
  });

  return result;
};
